import Contact from "../../entities/contact";

/**
 * Contact actions
 *
 * Call order:
 *
 * CONTACT_SAVE_QUEUE:	adds the item to the save queue
 * --> CONTACT_SAVE:	modifies the state
 * --> CONTACT_SAVE_SUCCESS: if all went well
 * --> CONTACT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail CONTACT_SAVE_QUEUE is during the call to CONTACT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const CONTACT_FETCH_ONE_QUEUE: any = 'CONTACT_FETCH_ONE_QUEUE';
export const CONTACT_FETCH_SUCCESS: any = 'CONTACT_FETCH_SUCCESS';
export const CONTACT_FETCH_FAILURE: any = 'CONTACT_FETCH_FAILURE';
export const CONTACT_FETCH_ONE_SUCCESS: any = 'CONTACT_FETCH_ONE_SUCCESS';
export const CONTACT_FETCH_ONE_FAILURE: any = 'CONTACT_FETCH_ONE_FAILURE';

export const CONTACT_SAVE: any = 'CONTACT_SAVE';
export const CONTACT_SAVE_QUEUE: any = 'CONTACT_SAVE_QUEUE';
export const CONTACT_SAVE_SUCCESS: any = 'CONTACT_SAVE_SUCCESS';
export const CONTACT_SAVE_FAILURE: any = 'CONTACT_SAVE_FAILURE';

export const CONTACT_SAVE_MANY: any = 'CONTACT_SAVE_MANY';
export const CONTACT_SAVE_MANY_QUEUE: any = 'CONTACT_SAVE_MANY_QUEUE';
export const CONTACT_SAVE_MANY_SUCCESS: any = 'CONTACT_SAVE_MANY_SUCCESS';
export const CONTACT_SAVE_MANY_FAILURE: any = 'CONTACT_SAVE_MANY_FAILURE';

export const CONTACT_REMOVE: any = 'CONTACT_REMOVE';
export const CONTACT_REMOVE_QUEUE: any = 'CONTACT_REMOVE_QUEUE';
export const CONTACT_REMOVE_SUCCESS: any = 'CONTACT_REMOVE_SUCCESS';
export const CONTACT_REMOVE_FAILURE: any = 'CONTACT_REMOVE_FAILURE';

export const CONTACT_RESTORE: any = 'CONTACT_RESTORE';
export const CONTACT_RESTORE_QUEUE: any = 'CONTACT_RESTORE_QUEUE';
export const CONTACT_RESTORE_SUCCESS: any = 'CONTACT_RESTORE_SUCCESS';
export const CONTACT_RESTORE_FAILURE: any = 'CONTACT_RESTORE_FAILURE';

export const CONTACT_RESTORE_MANY: any = 'CONTACT_RESTORE_MANY';
export const CONTACT_REMOVE_MANY: any = 'CONTACT_REMOVE_MANY';

/* Fetch actions */
export const fetchContactSuccess = (contacts: Contact[], partial: boolean, lastFetch: number) => ({type: CONTACT_FETCH_SUCCESS, contacts, partial, lastFetch});
export const fetchContactFailure = (err: any) => {
		console.error('ContactAction: fetchContactFailure', err);
		return {type: CONTACT_FETCH_FAILURE, err};
};
export const fetchOneContactQueue = (contactId: string) => ({type: CONTACT_FETCH_ONE_QUEUE, contactId});
export const fetchOneContactSuccess = (contact: Contact) => ({type: CONTACT_FETCH_ONE_SUCCESS, contact});
export const fetchOneContactFailure = (id: string, err: any) => {
		console.error('ContactAction: fetchOneContactFailure', err);
		return {type: CONTACT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveContact = (contact: Contact) => {
    // console.debug('⮂ CONTACT_SAVE action', contact?.id);
    return {type: CONTACT_SAVE, contact};
}
export const saveContactQueue = (contact: Contact, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CONTACT_SAVE_QUEUE action', contact?.id);
    return {type: CONTACT_SAVE_QUEUE, contact, onQueued};
}
export const saveContactSuccess = (contact: Contact) => {
    // console.debug('⮂ CONTACT_SAVE_SUCCESS action', contact?.id);
    return {type: CONTACT_SAVE_SUCCESS, contact};
}
export const saveContactFailure = (contact: Contact, status: number, message: string) => {
    console.warn(`⮂ CONTACT_SAVE_FAILURE error saving contact: HTTP ${status}: ${message}`, contact?.id);
    return {type: CONTACT_SAVE_FAILURE, contact, status, message};
};

/* SaveMany actions */
export const saveManyContacts = (contacts: Contact[]) => {
    // console.debug('⮂ CONTACT_SAVE_MANY action', contacts?.map(contact => contact?.id).join(','));
    return {type: CONTACT_SAVE_MANY, contacts};
}
export const saveManyContactsQueue = (contacts: Contact[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ CONTACT_SAVE_MANY_QUEUE action', contacts?.map(contact => contact.id).join(','));
    return {type: CONTACT_SAVE_MANY_QUEUE, contacts, onQueued};
}

export const saveManyContactsSuccess = (contacts: Contact[]) => {
    // console.debug('⮂ CONTACT_SAVE_MANY_SUCCESS action', contacts?.map(contact => contact.id).join(','));
    return {type: CONTACT_SAVE_MANY_SUCCESS, contacts};
}
export const saveManyContactsFailure = (contacts: Contact[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_CONTACTS_FAILURE Error saving contacts: HTTP ${status}: ${message}`, contacts?.map(contact => contact.id).join(','));
		return {type: CONTACT_SAVE_MANY_FAILURE, contacts, status, message};
};

/* Remove actions */
export const removeContact = (contact: Contact) => ({ type: CONTACT_REMOVE, contact });
export const removeContactQueue = (contact: Contact) => ({ type: CONTACT_REMOVE_QUEUE, contact });
export const removeContactSuccess = (contact: Contact) => ({ type: CONTACT_REMOVE_SUCCESS, contact });
export const removeContactFailure = (contact: Contact, status: number, message: string) => {
	console.error(`Redux: removeContactFailure Error removing contact: HTTP ${status}: ${message}`);
	return ({ type: CONTACT_REMOVE_FAILURE, contact, status, message });
};

/* Restore actions */
export const restoreContact = (contact: Contact) => ({ type: CONTACT_RESTORE, contact });
export const restoreContactQueue = (contact: Contact) => ({ type: CONTACT_RESTORE_QUEUE, contact });
export const restoreContactSuccess = (contact: Contact) => ({ type: CONTACT_RESTORE_SUCCESS, contact });
export const restoreContactFailure = (contact: Contact, status: number, message: string) => {
	console.error(`Redux: restoreContactFailure Error restoring contact: HTTP ${status}: ${message}`);
	return ({ type: CONTACT_RESTORE_FAILURE, contact, status, message });
};

/* RestoreMany actions */
export const restoreManyContacts = (contacts: Contact[]) => ({ type: CONTACT_RESTORE_MANY, contacts });

/* RemoveMany actions */
export const removeManyContacts = (contacts: Contact[]) => ({ type: CONTACT_REMOVE_MANY, contacts });